/**
 * Styles for icon controls that sit ON TOP of unknown content — a full-bleed
 * image, a PDF page, a video frame.
 *
 * A bare icon inherits `text-foreground`, which is only guaranteed to contrast
 * with the app's own surfaces. Over user-supplied media it can vanish entirely:
 * a dark X on an all-black photo leaves the preview with no visible way out.
 * These controls therefore carry their OWN surface — a near-opaque theme
 * background chip — so contrast is a property of the control, not of whatever
 * happens to be behind it.
 *
 * Theme-aware by construction: the chip is `bg-background` (white-ish in light
 * mode, near-black in dark mode) and the glyph is `text-foreground`, so the
 * pair clears AA in both themes over any content. Never hardcode white here.
 */

/** Icon button seated on a scrim chip — use over images/media, not app chrome. */
export const OVERLAY_ICON_BUTTON = [
  'inline-flex items-center justify-center rounded-full',
  'h-8 w-8 touch:h-11 touch:w-11',
  'bg-background/90 text-foreground shadow-sm ring-1 ring-border backdrop-blur-sm',
  'transition-colors hover:bg-background',
  'ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  'disabled:pointer-events-none',
].join(' ');
